import React from 'react'
import { BsCollectionPlayFill } from "react-icons/bs"

function CollectionTitleCard({ title }) {
    return (


        <div class="mx-auto lg:max-w-full sm:max-w-full p-4 bg-background-secondary-color  rounded-md shadow ">
            <h5 class="flex flex-inline item-center mb-2 text-2xl font-bold tracking-tight text-gray-200">
                <span className='mr-2'><BsCollectionPlayFill className='fill-green-500 mt-2 mr-3' /></span>
                {title}</h5>

        </div>

    )
}

export default CollectionTitleCard